<template>
  <div class="alert position-fixed" :class="'alert-' + classColor" role="alert"
    v-show="show" style="top: 60px; z-index: 1024; right: 36px; min-width: 200px;">
    {{ body }}
    <button type="button" class="close mx-2" @click="hide">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  props: ['message', 'color'],
  data() {
    return {
      show: false,
      body: '',
      classColor: 'danger',
    };
  },
  created() {
    if (this.message) {
      this.flash(this.message);
    }
    window.events.$on('flash', (message, color) => this.flash(message, color));
  },
  methods: {
    flash(message, color) {
      this.show = true;
      this.body = message;
      this.classColor = color;

      setTimeout(() => {
        this.hide();
      }, 8000);
    },
    hide() {
      this.show = false;
    },
  },
};
</script>

<style>
</style>
